import DeliveryService from 'src/common/api/delivery.service';

export async function fetchAllDeliveryMethods({ commit }) {
  const response = await DeliveryService.getAll();
  if (response.status === 200) {
    commit('updateAllDeliveryMethods', { deliveryMethods: response.data });
  }
}
